import React from 'react';
import cx from './BigNumber.scss';
import { numberFormat } from 'number-format';
import withStyles from 'decorators/withStyles';

function BigNumber({ number, label, className = '' }) {
  return (
    <div className={`${className} ${cx('main')}`}>
      <p className={cx('number')}>
        {numberFormat(number, 0, ',', ' ')}
      </p>
      <p className={cx('label')}>{label}</p>
    </div>
  );
}

export default withStyles(cx)(BigNumber);



// WEBPACK FOOTER //
// ./src/react/components/BigNumber/BigNumber.js